import React from 'react';
import loadable from '@loadable/component';
import { useAppStateContext } from '../../lib/AppStateProvider';
import { get } from '../../lib/getPropertyByPath'; 

const CTAVariation: any = loadable(() => 
  import(/* webpackChunkName: "CTAVariation" */ '@dtcm/ui-components/dist/components/113_CTAVariation/CTAVariation')
)

export const CTAVariationContainer = () => {
  const { appState } = useAppStateContext(); 

  if (!appState.footer || get(appState, 'dictionary.viewBag.isEmptyLayout', false)) {
    return null;
  }

  const {  footerSticky , footerStickyDictionary } = appState;

  const CTAVariationProps = {
    fields: {
      data: {
        item: footerSticky,
        dictionary: footerStickyDictionary
      }
    }
  }

  return (
    footerSticky ? <CTAVariation  {...CTAVariationProps}/> : <></>
  );
};

// default exports are encouraged for dynamic imports
export default CTAVariationContainer;
